import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { NavLink, Link } from 'react-router-dom';
import $ from 'jquery';
import StartDatePicker from './StartDatePicker/StartDatePicker';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import Checkbox from '@mui/material/Checkbox';
import lastOperationsIcon from './../img/last-operations-icon.png';
import { request } from '../../../config';
import YesNoModal from "../../../copms/Modal/YesNoModal"
import AsanVerification from '../../../copms/Modal/AsanVerification';
import { Autocomplete, Radio, TextField } from '@mui/material';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class List extends Component {
    state = {
        status: 1,
        endDate: null,
        beginDate: null,
        currentPage: 1,
        lastPage: 0,
        instructions: [],
        id: null,
        checkedItems: [],
        selectAllChecked: false,
        verificationOpen: false,
        verificationCode: null,
        orderTypes: [{
            id: null,
            label: this.props.t('all')
        },
        {
            id: 1,
            label: this.props.t('Alınmalı')
        },
        {
            id: 2,
            label: this.props.t('Doldurulmalı')
        }],
        orderType: null,
        instructionNumber: '',
        bencName: '',
        open: false,
        item: null,
        payType: null,
        payableAmount: '',
        calculatedAmount: '',
        accountId: null,
        totalAmountWithComission: null,
        commission: null,
        isBlocked: 0
    }

    // downloadFile = (bytes, name) => {
    //     let arrrayBuffer = base64ToArrayBuffer(bytes);
    //     saveFile(name, "application/pdf", arrrayBuffer)
    // }

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    getFormatedDate(date) {
        if (date) {
            let formatedDate = {
                day: (date.getDate() < 10) ? ('0' + date.getDate()) : date.getDate(),
                month: (date.getMonth() < 10) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1),
                year: date.getFullYear().toString()
            }
            return formatedDate.year + '-' + formatedDate.month + '-' + formatedDate.day;
        }
        return null;
    }

    selectPage(e, page) {
        e.preventDefault();
        this.setState({ currentPage: page }, () => this.getActiveInstructions())
    }

    componentDidMount() {
        this.getActiveInstructions();
    }

    getActiveInstructions = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getActiveInstructionsRequestBody = {
            token: localStorage.getItem('token'),
            beginDate: this.getFormatedDate(this.state.beginDate),
            endDate: this.getFormatedDate(this.state.endDate),
            orderType: this.state.orderType,
            instructionNumber: this.state.instructionNumber.trim(),
            bencName: this.state.bencName.trim(),
            pageNumber: this.state.currentPage,
        }
        fetch(request("instruction/getActiveInstructions", getActiveInstructionsRequestBody))
            .then(res => res.text())
            .then((getActiveInstructionsResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getActiveInstructionsResponse = JSON.parse(getActiveInstructionsResponseJSON);
                if (getActiveInstructionsResponse.status.statusCode !== 1) {
                    if (getActiveInstructionsResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getActiveInstructionsResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    if (getActiveInstructionsResponse.isBlocked) {
                        this.props.alertState(true, 'warning', null, this.props.t('decree info'));
                    }
                    this.setState({ item: null, isBlocked: getActiveInstructionsResponse.isBlocked, lastPage: getActiveInstructionsResponse.totalPage, instructions: getActiveInstructionsResponse.instructions ? getActiveInstructionsResponse.instructions : [] });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getPaymentSelection = (item) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getPaymentSelectionRequestBody = {
            token: localStorage.getItem('token'),
            id: item.id,
            ordcInn: item.ordcInn,
        }
        fetch(request("instruction/getPaymentSelection", getPaymentSelectionRequestBody))
            .then(res => res.text())
            .then((getPaymentSelectionResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getPaymentSelectionResponse = JSON.parse(getPaymentSelectionResponseJSON);
                if (getPaymentSelectionResponse.status.statusCode !== 1) {
                    if (getPaymentSelectionResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getPaymentSelectionResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.setState({ data: getPaymentSelectionResponse });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    calculateCommission = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let calculateCommissionRequestBody = {
            token: localStorage.getItem('token'),
            payableAmount: this.state.payableAmount,
            feePercent: this.state.data.payments.find(item => item.payAble == 1).feePercent,
            feeMaxAmount: this.state.data.payments.find(item => item.payAble == 1).feeMaxAmount,
            feeMinAmount: this.state.data.payments.find(item => item.payAble == 1).feeMinAmount,
        }
        fetch(request("instruction/calculateCommission", calculateCommissionRequestBody))
            .then(res => res.text())
            .then((calculateCommissionResponseJSON) => {
                const JSON = require('true-json-bigint');
                let calculateCommissionResponse = JSON.parse(calculateCommissionResponseJSON);
                if (calculateCommissionResponse.status.statusCode !== 1) {
                    if (calculateCommissionResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(calculateCommissionResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.setState({ calculatedAmount: this.state.payableAmount, totalAmountWithComission: calculateCommissionResponse.totalAmount.toFixed(2), commission: calculateCommissionResponse.commissionAmount.toFixed(2) });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getSignFile = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let certCode = customerType == 'Juridical' ? JSON.parse(localStorage.getItem('custObject')).company.certCode : JSON.parse(localStorage.getItem('custObject')).certCode
        let getSignFileRequestBody = {
            token: localStorage.getItem('token'),
            abonCode: this.state.data.abonCode,
            accountId: this.state.accountId,
            payType: this.state.payType,
            collDocumentId: this.state.data.collDocumentId,
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            certCode: certCode,
            userId: localStorage.getItem('userId'),
            phoneNumber: localStorage.getItem('phoneNumber'),
            transactionId: 0,
            reqPeymantDetails: this.state.payType == 1 ? this.state.data.payments.map(item => ({
                serviceName: item.serviceName, budgetCode: item.budgetClassCode, budgetLevelCode: item.budgetLevelCode,
                amount: item.remainingDebt, feeAmount: item.commission, serviceCode: item.serviceCode, fullName: item.fullName, subType: item.subType
            })) : this.state.data.payments.filter(item => item.payAble == 1).map(item => ({
                serviceName: item.serviceName, budgetCode: item.budgetClassCode, budgetLevelCode: item.budgetLevelCode,
                amount: this.state.calculatedAmount, feeAmount: this.state.commission, serviceCode: item.serviceCode, fullName: item.fullName, subType: item.subType
            }))
        }
        fetch(request("instruction/getSignFile", getSignFileRequestBody))
            .then(res => res.text())
            .then((getSignFileResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getSignFileResponse = JSON.parse(getSignFileResponseJSON);
                if (getSignFileResponse.status.statusCode !== 1) {
                    if (getSignFileResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getSignFileResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.setState({ verificationOpen: true, verificationCode: getSignFileResponse.verificationCode })
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    let signFileRequestBody = {
                        collDocumentId: this.state.data.collDocumentId,
                        token: localStorage.getItem('token'),
                        lang: localStorage.getItem('i18nextLng').toUpperCase(),
                        transactionId: getSignFileResponse.transactionId,
                        certCode: certCode,
                        userId: localStorage.getItem('userId'),
                        phoneNumber: localStorage.getItem('phoneNumber')
                    }
                    fetch(request("instruction/signFile", signFileRequestBody))
                        .then(res => res.text())
                        .then((signFileResponseJSON) => {
                            const JSON = require('true-json-bigint');
                            let signFileResponse = JSON.parse(signFileResponseJSON);
                            if (signFileResponse.status.statusCode !== 1) {
                                if (signFileResponse.status.statusCode === 200) {
                                    this.props.logout();
                                } else {
                                    this.setState({ verificationOpen: false });
                                    this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(signFileResponse.status.statusCode));
                                }
                            } else {
                                this.props.updateAppState('isLoadingTransparentBackground', true);
                                this.setState({ verificationOpen: false });
                                fetch(request("instruction/createAbsTransaction", { ...getSignFileRequestBody, transactionId: this.state.data.transactionId, operId: signFileResponse?.successStatus[0]?.operId }))
                                    .then(res => res.text())
                                    .then((createAbsTransactionResponseJSON) => {
                                        const JSON = require('true-json-bigint');
                                        let createAbsTransactionResponse = JSON.parse(createAbsTransactionResponseJSON);
                                        if (createAbsTransactionResponse.status.statusCode !== 1) {
                                            if (createAbsTransactionResponse.status.statusCode === 200) {
                                                this.props.logout();
                                            } else {
                                                this.props.updateAppState('isLoadingTransparentBackground', false);
                                                this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(createAbsTransactionResponse.status.statusCode));
                                            }
                                        } else {
                                            this.setState({ open: false });
                                            this.props.updateAppState('isLoadingTransparentBackground', false);
                                            this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(createAbsTransactionResponse.status.statusCode), null, null, this.getActiveInstructions);
                                        }
                                    });
                            }
                        });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getFile = (id, filename) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getFileRequestBody = {
            token: localStorage.getItem('token'),
            id
        }
        fetch(request("instruction/getFile", getFileRequestBody))
            .then(res => res.text())
            .then((getFileResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getFileResponse = JSON.parse(getFileResponseJSON);
                if (getFileResponse.status.statusCode !== 1) {
                    if (getFileResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getFileResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    let arrrayBuffer = base64ToArrayBuffer(getFileResponse.file);
                    saveFile(filename, "application/pdf", arrrayBuffer)
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    render() {
        let { verificationOpen, verificationCode, instructions, selectAllChecked, checkedItems, orderTypes, orderType, beginDate, endDate, instructionNumber, bencName,
            open, item, data, checked, payType, payableAmount, accountId, calculatedAmount, totalAmountWithComission, commission, isBlocked
        } = this.state;
        let { t, alertState } = this.props;
        return (
            <>
                <AsanVerification open={verificationOpen} verificationCode={verificationCode} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('orders')}</h2>
                    </div>
                </div>
                <div className="dashboard-salary-container">
                    <div className="dashboard-salary-container-data-section" style={{ marginTop: '1px' }}>
                        <div className="dashboard-transfer-list-header">
                            <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                                <NavLink exact to="/dashboard/decree/list" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Active orders")}</NavLink>
                                <NavLink exact to="/dashboard/decree/history" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("history")}</NavLink>
                                <NavLink exact to="/dashboard/decree/other-bank-paid" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Other bank paid orders")}</NavLink>
                            </div>
                        </div>
                        <div className="dashboard-salary-order-container">
                            <div className="dashboard-salary-order-container-box flex-nowrap">
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Document type")}</label>
                                    <Autocomplete
                                        options={orderTypes}
                                        value={orderTypes.find(item => item.id == orderType) || orderTypes[0]}
                                        onChange={(event, value) => this.setState({ orderType: value.id })}
                                        disableClearable
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Order number")}</label>
                                    <TextField value={instructionNumber} onChange={(e) => this.setState({ instructionNumber: e.target.value })} helperText={t('Sərəncam nömrəsi 12 simvoldan az olmamalıdır.')} />
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Sending organization")}</label>
                                    <TextField value={bencName} onChange={(e) => this.setState({ bencName: e.target.value })} />
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Started date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <StartDatePicker value={beginDate} name="beginDate" endDate={endDate} disableFuture={true} updateDate={this.updateDate} />
                                    </div>
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("expiration date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <EndDatePicker value={endDate} name="endDate" beginDate={beginDate} disableFuture={true} updateDate={this.updateDate} />
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-salary-order-container-box justify-content-end">
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" disabled={instructionNumber && instructionNumber.length < 12} onClick={this.getActiveInstructions}>{t("Search")}</button>
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" onClick={() => this.setState({ orderType: orderTypes[0].id, instructionNumber: '', bencName: '', beginDate: null, endDate: null })}>{t("Clear")}</button>
                            </div>
                            {instructions.length === 0 ?
                                <div className="dashboard-last-operations-section-content" style={{ justifyContent: 'center' }}>
                                    <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                    <p className="dashboard-last-operations-section-content-status">{t('you do not currently have any active transactions')}</p>
                                </div>
                                : <>
                                    <table>
                                        <thead>
                                            <tr>
                                                {(localStorage.getItem("isAsan") === "true" && !isBlocked) && <th></th>}
                                                <th>{t("date")}</th>
                                                <th>{t("Order number")}</th>
                                                <th>{t("Sending organization")}</th>
                                                <th>{t("Document type")}</th>
                                                <th>{t("Amount")}</th>
                                                <th>{t("Balance")}</th>
                                                <th>{t("Document")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {instructions.length !== 0 && instructions.map(item => (
                                                <tr>
                                                    {(localStorage.getItem("isAsan") === "true" && !isBlocked && item.canPay) && <td>
                                                        <Radio
                                                            checked={this.state.item?.id == item.id}
                                                            onChange={(e) => { this.setState({ item: e.target.checked ? item : null }); e.target.checked && this.getPaymentSelection(item) }}
                                                            value={item.id}
                                                            sx={{
                                                                color: "#DADADA",
                                                                "&.Mui-checked": {
                                                                    color: "#0179D2",
                                                                },
                                                            }}
                                                        />
                                                    </td>}
                                                    <td>{item.collDate || '--'}</td>
                                                    <td>{item.collNum || '--'}</td>
                                                    <td>{item.bencName || '--'}</td>
                                                    <td>{item.collTypeName || '--'}</td>
                                                    <td>{item.amount || '--'}</td>
                                                    <td>{item.rest || '--'}</td>
                                                    <td>
                                                        <button onClick={() => this.getFile(item?.id, `Sərəncam № ${item?.collNum}`)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M2.70039 2.4C2.70039 1.2402 3.64059 0.3 4.80039 0.3H14.2761L21.3004 7.32426V21.6C21.3004 22.7598 20.3602 23.7 19.2004 23.7H4.80039C3.64059 23.7 2.70039 22.7598 2.70039 21.6V2.4Z" stroke="#344054" stroke-width="0.6" />
                                                                <path d="M14.4004 0L21.6004 7.2H16.8004C15.4749 7.2 14.4004 6.12548 14.4004 4.8V0Z" fill="#344054" />
                                                                <path d="M15.0449 15.1168C14.4461 15.1168 13.6966 15.2212 13.4514 15.258C12.4367 14.1983 12.1479 13.5959 12.083 13.4353C12.171 13.2092 12.4772 12.3502 12.5207 11.2469C12.5422 10.6946 12.4255 10.2818 12.1738 10.0202C11.9226 9.75896 11.6185 9.73865 11.5313 9.73865C11.2255 9.73865 10.7126 9.89327 10.7126 10.9287C10.7126 11.8271 11.1314 12.7804 11.2472 13.0267C10.6372 14.803 9.98224 16.0189 9.84317 16.269C7.39189 17.1919 7.2002 18.0843 7.2002 18.3372C7.2002 18.7917 7.52387 19.063 8.06602 19.063C9.38324 19.063 10.5853 16.8516 10.784 16.4676C11.7196 16.0948 12.9717 15.8639 13.29 15.8088C14.2031 16.6786 15.2591 16.9107 15.6976 16.9107C16.0275 16.9107 16.8002 16.9107 16.8002 16.1162C16.8002 15.3785 15.8547 15.1168 15.0449 15.1168ZM14.9814 15.6383C15.6929 15.6383 15.8809 15.8736 15.8809 15.998C15.8809 16.0761 15.8513 16.3308 15.4699 16.3308C15.128 16.3308 14.5375 16.1331 13.9566 15.7043C14.1989 15.6725 14.5574 15.6383 14.9814 15.6383ZM11.4939 10.2442C11.5588 10.2442 11.6015 10.265 11.6367 10.3138C11.8414 10.5978 11.6764 11.5256 11.4755 12.2516C11.2817 11.6291 11.1362 10.6738 11.3409 10.3378C11.3809 10.2722 11.4266 10.2442 11.4939 10.2442ZM11.1484 15.8014C11.406 15.281 11.6947 14.5226 11.852 14.0937C12.1666 14.6204 12.5899 15.1095 12.8347 15.3746C12.0725 15.5353 11.4958 15.6958 11.1484 15.8014ZM7.71188 18.4066C7.69491 18.3865 7.6924 18.3441 7.70519 18.2931C7.732 18.1864 7.93695 17.6573 9.41928 16.9942C9.20703 17.3285 8.87521 17.8062 8.51069 18.1631C8.25409 18.4033 8.05429 18.5251 7.91682 18.5251C7.86764 18.5251 7.79989 18.5117 7.71188 18.4066Z" fill="#344054" />
                                                            </svg>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {(localStorage.getItem("isAsan") === "true" && !isBlocked) &&
                                        <div className="dashboard-salary-order-container-box justify-content-end">
                                            <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" disabled={!item} onClick={() => this.setState({ payType: 1, open: true })}>{t("Full payment")}</button>
                                            <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" disabled={!item} onClick={() => this.setState({ payType: 2, open: true })}>{t("Partial payment")}</button>
                                        </div>
                                    }
                                    <div style={{ width: '100%', marginTop: '15px', marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                                        <ul className="dashboard-pagination">
                                            {this.state.currentPage != 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage - 1)}>{t('previous-page')}</a></li>}
                                            {
                                                Array.from({ length: this.state.lastPage }).map((item, index) => {
                                                    if (this.state.lastPage > 3) {
                                                        if (this.state.currentPage - 1 == index + 1) {
                                                            return (
                                                                <>
                                                                    {this.state.currentPage > 2 && <li><a href="#" onClick={(e) => this.selectPage(e, 1)}>1</a></li>}

                                                                    {this.state.currentPage > 3 && <li><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}
                                                                    <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                                </>
                                                            )
                                                        }
                                                        if (this.state.currentPage == index + 1) {
                                                            return (
                                                                <>
                                                                    <li className="active" ><a href="#" style={{ cursor: 'default' }} onClick={e => e.preventDefault()}>{index + 1}</a></li>
                                                                </>
                                                            )
                                                        }
                                                        if (this.state.currentPage + 1 == index + 1) {
                                                            return (
                                                                <>
                                                                    <li><a href="#" onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                                    {this.state.currentPage < this.state.lastPage - 2 && <li ><a href="#" style={{ cursor: 'default' }} onClick={(e) => { e.preventDefault(); }}>...</a></li>}
                                                                    {this.state.currentPage + 1 < this.state.lastPage && <li ><a href="#" onClick={(e) => this.selectPage(e, this.state.lastPage)}>{this.state.lastPage}</a></li>}
                                                                </>
                                                            )
                                                        }
                                                    } else {
                                                        return (
                                                            <li className={index + 1 == this.state.currentPage ? "active" : ""}><a href="#" style={this.state.lastPage == 1 ? { borderRadius: '5px' } : {}} onClick={(e) => this.selectPage(e, index + 1)}>{index + 1}</a></li>
                                                        )
                                                    }
                                                })
                                            }
                                            {this.state.currentPage != this.state.lastPage && this.state.lastPage > 1 && <li><a href="#" onClick={(e) => this.selectPage(e, this.state.currentPage + 1)}>{t('next-page')}</a></li>}
                                        </ul>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
                <Modal
                    open={open}
                    onClose={() => this.setState({ open: false })}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    aria-labelledby="spring-modal-title"
                    aria-describedby="spring-modal-description">
                    <Fade in={open}>
                        <div style={{ display: 'inline-block', maxHeight: '100vh', overflow: 'auto' }}>
                            <div className="dashboard-account-container dashboard-account-container-component-block decree">
                                <div className="dashboard-account-container-component w-100">
                                    <h3>{t('Tax order')}</h3>
                                    <TextField value={data?.collDocumentId} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('Document number')} />
                                    <TextField value={data?.collNum} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('Order number')} />
                                    <TextField value={data?.collTypeName} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('Document type')} />
                                    <TextField value={data?.collPost} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('The purpose of the payment')} />
                                    <hr style={{ width: '100%', background: '#0179D2' }} />
                                    <h3>{t('Beneficiary (Receiving Bank)')}</h3>
                                    <TextField value={data?.benbName} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('First name')} />
                                    <TextField value={data?.benbCode} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('Code')} />
                                    <TextField value={data?.benbInn} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('tin')} />
                                    <TextField value={data?.benbSwiftCode} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('SWIFT code')} />
                                    <TextField value={data?.benbAcc} sx={{ width: 532 }} InputProps={{ readOnly: true }} label={t('Correspondent account')} />
                                    <hr style={{ width: '100%', background: '#0179D2' }} />
                                    <h3>{t('Receiving customer')}</h3>
                                    <TextField value={data?.bencName} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('First name')} />
                                    <TextField value={data?.bencInn} sx={{ width: 250 }} InputProps={{ readOnly: true }} label={t('tin')} />
                                    <TextField value={data?.bencAcc} sx={{ width: 532 }} InputProps={{ readOnly: true }} label={t('account number')} />
                                    <hr style={{ width: '100%', background: '#0179D2' }} />
                                    <h3>{t('Payment details')}</h3>
                                    {data?.payments && data?.payments.map((item, index) => <>
                                        <div className='d-flex flex-wrap' style={{ gap: '1rem' }}>
                                            <TextField value={item?.budgetClassCode} sx={{ width: 160 }} InputProps={{ readOnly: true }} label={t('Budget classification code')} />
                                            <TextField value={item?.budgetLevelCode} sx={{ width: 160 }} InputProps={{ readOnly: true }} label={t('Budget level code')} />
                                            <TextField value={item?.paymentAmount} sx={{ width: 160 }} InputProps={{ readOnly: true }} label={t('Amount')} />
                                            <TextField value={item?.remainingDebt} sx={{ width: 160 }} InputProps={{ readOnly: true }} label={t('Outstanding debt')} />
                                            {payType == 2 && <TextField sx={{ width: 160, '.MuiInputLabel-root:not(.Mui-error)': { color: item.payAble == 1 && '#1976d2' }, '.Mui-error fieldset': { borderColor: '#d32f2f!important' }, 'label.Mui-error': { color: '#d32f2f!important' } }}
                                                value={item.payAble == 1 ? payableAmount : ''}
                                                error={item.payAble == 1 && Number(payableAmount) > item?.remainingDebt}
                                                onChange={(e) => (e.target.value == '' || /^\d+(\.\d{0,2})?$/.test(e.target.value)) && this.setState({ payableAmount: e.target.value })}
                                                disabled={item.payAble == 0} label={t('Amount to be paid')} />}
                                        </div>
                                        <hr className='w-100' />
                                    </>)}
                                    <TextField value={payType == 1 ? data?.commission : commission} sx={{ width: 100 }} InputProps={{ readOnly: true }} label={t('Commission')} />
                                    <TextField value={payType == 1 ? data?.totalAmountWithComission : totalAmountWithComission} sx={{ width: 100 }} InputProps={{ readOnly: true }} label={t('Total amount')} />
                                    <Autocomplete
                                        sx={{ width: 430, '.MuiOutlinedInput-root': { background: 'white' }, '.MuiInputLabel-root': { color: '#1976d2' } }}
                                        options={data?.accountList || []}
                                        getOptionLabel={option => option.iban + " / " + option.balance + " " + option.currencyName}
                                        value={data?.accountList?.find(item => item.accountId == accountId) || null}
                                        onChange={(event, value) => this.setState({ accountId: value?.accountId })}
                                        disableClearable
                                        renderInput={(params) => <TextField label={t('Account for payment')} {...params} />}
                                    />
                                    <div className="dashboard-salary-order-container-box w-100">
                                        <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main ml-auto" disabled={payType == 2 ? (payableAmount == '' || payableAmount == 0 || !accountId || Number(payableAmount) > data?.payments?.find(item => item.payAble == 1)?.remainingDebt) : !accountId} onClick={() => (payType == 2 && calculatedAmount != payableAmount) ? this.calculateCommission() : this.getSignFile()}>{(payType == 2 && calculatedAmount != payableAmount) ? t("Calculate commission") : t("Confirm")}</button>
                                        <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" onClick={() => this.setState({ open: false })}>{t("close")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fade>
                </Modal>
            </>
        )
    }
}

export default translate("translation")(List);